import { TransferTransactionStatusType } from '@golden/gdk-base';
import { AdminTransferTransactionStatusType } from '../enums/AdminTransferTransactionStatusType';
export const transferTransactionTypeMapAdminTransferTransactionType = {
    [TransferTransactionStatusType.IN_PROGRESS]: AdminTransferTransactionStatusType.IN_PROGRESS,
    [TransferTransactionStatusType.SUCCESSFUL]: AdminTransferTransactionStatusType.SUCCESSFUL,
    [TransferTransactionStatusType.FAIL]: AdminTransferTransactionStatusType.FAIL,
    [TransferTransactionStatusType.FAIL_THIRD_PARTY]: AdminTransferTransactionStatusType.ROLLBACK,
    [TransferTransactionStatusType.ERROR]: AdminTransferTransactionStatusType.ERROR
};
//# sourceMappingURL=transferTransactionTypeMapAdminTransferTransactionType.js.map